import { Button, ButtonProps, forwardRef } from '@chakra-ui/react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Icon } from '~/ui-components';

type FilterButtonProps = ButtonProps & {
   label: string;
   icon: IconDefinition;
   selected: number | boolean;
};

export const FilterButton = forwardRef<FilterButtonProps, 'div'>(
   ({ label, icon, selected, ...buttonProps }: FilterButtonProps, ref) => (
      <Button
         ref={ref}
         px={3}
         py={1}
         transition="all 0.2s"
         borderRadius="xl"
         borderWidth="1px"
         _hover={{ bg: 'gray.100' }}
         _focus={{ boxShadow: 'outline' }}
         rightIcon={<Icon type={icon} fontSize="11px" />}
         color={selected ? 'blue.500' : undefined}
         backgroundColor={selected ? 'blue.100 ' : undefined}
         borderColor={selected ? 'blue.500' : undefined}
         {...buttonProps}
      >
         {label} {typeof selected === 'number' && selected ? `(${selected})` : null}
      </Button>
   )
);
